import { TableRowSelection } from "@/types/message";
import { useCallback, useMemo, useState } from "react";






/**
 * 表格 多选
 * @param props 
 * @returns 
 */
const useRowSelection = (rowSelectionConfig?:any) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);//已选中的项
  /**
   * 选中项改变事件
   */
  const onSelectChange = useCallback((newSelectedRowKeys: React.Key[]) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  },[]);
  const rowSelection: TableRowSelection<any> = useMemo(() =>{
    return {
     selectedRowKeys,
     onChange: onSelectChange,
     ...rowSelectionConfig
   }
 },[selectedRowKeys,onSelectChange]);
  return {rowSelection,selectedRowKeys,setSelectedRowKeys};  
}


export default useRowSelection;